import React, { Component } from 'react';
import { connect } from 'react-redux';
import getSelectedHotelsRoomsWithSelectedOption from 'state/checkoutPage/packagesSearch/selectors/getSelectedHotelsRoomsWithSelectedOption';
import HotelSummaryComponent from './HotelSummaryComponent';

class HotelSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rooms: [],
    };

    this.setSelectedRooms = this.setSelectedRooms.bind(this);
    const { summaryType, packagesSearchHotel, exclusive } = props;
    this.summaryKey = { summaryType, id: packagesSearchHotel.id, exclusive };
  }

  componentDidMount() {
    const { selectedRooms } = this.props;

    if (selectedRooms) {
      this.setSelectedRooms();
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedRooms } = this.props;
    const { selectedRooms: prevSelectedRooms } = prevProps;

    if (selectedRooms && selectedRooms !== prevSelectedRooms) {
      this.setSelectedRooms();
    }
  }

  setSelectedRooms() {
    const {
      getSelectedHotelsRoomsWithSelectedOption,
      packagesSearchHotel: { id },
    } = this.props;

    const rooms = transformSelectedRooms(getSelectedHotelsRoomsWithSelectedOption({ hotelId: id }));
    this.setState({
      rooms,
    });
  }

  render() {
    const { packagesSearchHotel, hotelInfo = {} } = this.props;
    const { rooms } = this.state;
    const { checkIn: checkInDateTime, checkOut: checkOutDateTime } = packagesSearchHotel;
    const { name, checkIn, checkOut } = hotelInfo;

    return (
      <HotelSummaryComponent
        summaryKey={this.summaryKey}
        title={name}
        // image={!hideImage && images[0]}
        checkInDateTime={checkInDateTime}
        checkOutDateTime={checkOutDateTime}
        checkInTime={checkIn}
        checkOutTime={checkOut}
        rooms={rooms}
      />
    );
  }
}

function mapStateToProps(state, ownProps) {
  const hotelInfo = state.hotelPage.hotelsInfo.find((hotelInfo) => hotelInfo.id === ownProps.packagesSearchHotel.id);

  return {
    hotelInfo,
    checkoutWizard: state.checkoutPageWizard,
    selectedRooms: state.checkoutPageTravelSummary.selectedRooms,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSelectedHotelsRoomsWithSelectedOption(config) {
      return dispatch(getSelectedHotelsRoomsWithSelectedOption(config));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HotelSummary);

// Utility function

function transformSelectedRooms(selectedRooms) {
  return selectedRooms.map((selectedRoom) => {
    return {
      productToken: selectedRoom.selectedOption.productToken,
      roomName: selectedRoom.selectedOption.name,
      boardName: selectedRoom.selectedOption.board.name,
      numberOfAdults: selectedRoom.adults,
      numberOfChildren: selectedRoom.childages.length,
    };
  });
}
